import React from "react";
import { Helmet } from "react-helmet";

import {
  Navbar,
  Footer,
  Landing,
  About,
  Testimonials,
  // Blog,
  Education,
  // Experience,
  Contacts,
  Projects,
  ServicesNew,
  // Services,
  // Achievement,
  PriceList,
} from "../../components";
import { headerData } from "../../data/headerData";
import ExperienceFizjo from "../../components/ExperienceFizjo/ExperienceFizjo";

function Main() {
  return (
    <div>
      <Helmet>
        <title>{headerData.name}</title>
      </Helmet>

      <Navbar />
      <Landing />
      <About />
      <Education />
      <ExperienceFizjo />
      {/* <Skills /> */}
      <Projects />
      {/* <Achievement /> */}
      {/* <Services /> */}
      <ServicesNew />
      <Testimonials />
      <PriceList />
      {/* <Blog /> */}
      <Contacts />
      <Footer />
    </div>
  );
}

export default Main;
